// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  } */

  .modal {
    position: absolute;
    z-index: 999;
    left: 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 50%;
    height: 60%;
    margin-top: 10px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    box-sizing: unset;
}
  
  .modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    box-sizing: unset;
  }

  .modal-content-scroll {
    background-color: #fff;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    box-sizing: unset;
}

/* Hide scrollbar for webkit browsers */
.modal-content-scroll::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

  .modal-item {
    padding: 10px;
    border-radius: 5px;
    background-color: #f5f5f5;
    margin-bottom: 10px;
    cursor: pointer;
  }
  
  .modal-item:hover {
    background-color: #e5e5e5;
  }
  
  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    font-weight: bold;
    color: #999;
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
  }

  .fileManagerButton {
    display: inline-block;
    padding: 10px 10px; 
    border-radius: 5px; 
    cursor: pointer;
  }

  .fileManagerButton:hover {
    background-color: #e5e5e5;
  }

  .fileManagerButton:active {
    background-color: #999;
    color: white;
  }

  .close-button:hover {
    color: #333;
  }
  
  .clear-icon {
    position: absolute;
    right: 0px;
    top: 0px;
    cursor: pointer;
}

div.scroll {
    height:170px;
    overflow:auto;

}

.uppy-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.uppy-modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 500px;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.uppy-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.uppy-modal-header h2 {
  margin: 0;
  font-size: 24px;
}

.uppy-modal-close {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.uppy-modal-close:hover,
.uppy-modal-close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

/* input,
textarea {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;
} */

#root_title,
#root_n_cells,
#root_reference {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;
}

#root_summary {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  resize: vertical;
  width: 100%;
}

button[type="submit"] {
  background-color: #3c5379;
  border-radius: 5px;
  color: #fff;
  padding: 10px 20px;
}

.selectFiles {
  border: unset;
  border-radius: unset;
  padding: unset;
  margin-bottom: unset;
  width: unset;
}

#upload-data-div {
  background-color: lightblue;
  border-radius: 10px;
  padding: 10px;
}

#upload-data-div .folder-button {
 margin-top: 5px;
}

*, :after, :before {
  /* border: unset; */
  box-sizing: unset;
}

.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.unsupported-format {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.preview-message {
  margin-left: 10px;
}

.preview-message {
  margin-left: 10px;
}

.info-icon {
  position: relative;
  /* top: 10px; */
  right: 10px;
  width: 30px;
  height: 30px;
  background-color: lightgrey;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
  float: right;
}

.info-icon:hover {
  background-color: darkgrey;
}
`, "",{"version":3,"sources":["webpack://./src/components/MyData/ModalWindow.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;KAWK;;EAEH;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,yCAAyC;IACzC,iBAAiB;AACrB;;EAEE;IACE,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,uCAAuC;AACvC;IACI,UAAU;IACV,uBAAuB;AAC3B;;EAEE;IACE,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;;AAEjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;;;;;GAOG;;AAEH;;;EAGE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* .modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  } */\n\n  .modal {\n    position: absolute;\n    z-index: 999;\n    left: 25%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 50%;\n    height: 60%;\n    margin-top: 10px;\n    background-color: #fff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n    box-sizing: unset;\n}\n  \n  .modal-content {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 5px;\n    width: 100%;\n    height: 100%;\n    overflow-y: auto;\n    box-sizing: unset;\n  }\n\n  .modal-content-scroll {\n    background-color: #fff;\n    border-radius: 5px;\n    width: 100%;\n    height: 100%;\n    overflow-y: scroll;\n    box-sizing: unset;\n}\n\n/* Hide scrollbar for webkit browsers */\n.modal-content-scroll::-webkit-scrollbar {\n    width: 0px;\n    background: transparent;\n}\n\n  .modal-item {\n    padding: 10px;\n    border-radius: 5px;\n    background-color: #f5f5f5;\n    margin-bottom: 10px;\n    cursor: pointer;\n  }\n  \n  .modal-item:hover {\n    background-color: #e5e5e5;\n  }\n  \n  .close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 20px;\n    font-weight: bold;\n    color: #999;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    outline: none;\n  }\n\n  .fileManagerButton {\n    display: inline-block;\n    padding: 10px 10px; \n    border-radius: 5px; \n    cursor: pointer;\n  }\n\n  .fileManagerButton:hover {\n    background-color: #e5e5e5;\n  }\n\n  .fileManagerButton:active {\n    background-color: #999;\n    color: white;\n  }\n\n  .close-button:hover {\n    color: #333;\n  }\n  \n  .clear-icon {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    cursor: pointer;\n}\n\ndiv.scroll {\n    height:170px;\n    overflow:auto;\n\n}\n\n.uppy-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.uppy-modal-content {\n  background-color: #fefefe;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 80%;\n  max-width: 500px;\n  border-radius: 5px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.uppy-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.uppy-modal-header h2 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.uppy-modal-close {\n  color: #aaa;\n  font-size: 28px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.uppy-modal-close:hover,\n.uppy-modal-close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n/* input,\ntextarea {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 10px;\n  margin-bottom: 10px;\n  width: 100%;\n} */\n\n#root_title,\n#root_n_cells,\n#root_reference {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 10px;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n#root_summary {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 10px;\n  margin-bottom: 10px;\n  resize: vertical;\n  width: 100%;\n}\n\nbutton[type=\"submit\"] {\n  background-color: #3c5379;\n  border-radius: 5px;\n  color: #fff;\n  padding: 10px 20px;\n}\n\n.selectFiles {\n  border: unset;\n  border-radius: unset;\n  padding: unset;\n  margin-bottom: unset;\n  width: unset;\n}\n\n#upload-data-div {\n  background-color: lightblue;\n  border-radius: 10px;\n  padding: 10px;\n}\n\n#upload-data-div .folder-button {\n margin-top: 5px;\n}\n\n*, :after, :before {\n  /* border: unset; */\n  box-sizing: unset;\n}\n\n.spinner-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.unsupported-format {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.preview-message {\n  margin-left: 10px;\n}\n\n.preview-message {\n  margin-left: 10px;\n}\n\n.info-icon {\n  position: relative;\n  /* top: 10px; */\n  right: 10px;\n  width: 30px;\n  height: 30px;\n  background-color: lightgrey;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  float: right;\n}\n\n.info-icon:hover {\n  background-color: darkgrey;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
